const getBaseUrl = () => {
    const url = process.env.REACT_APP_BASE_URL;
    if (!url) return "";
    return url.startsWith("http") ? url : `http://${url}`;
};

const API_BASE_URL = getBaseUrl();
console.log('API_BASE_URL:', API_BASE_URL);
export { API_BASE_URL };